import React from "react";
import { LegalLayout, Section, P } from "../components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      eyebrow="Terms · Canada"
      title="Terms of Use"
      intro="These Terms govern your use of the SmartPeptides Hub and explain the boundaries of activation, linked services, distributor access, and health-related content."
      updatedOn="July 2026"
    >
      <Section number="01" title="Acceptance of these Terms">
        <P>
          These Terms of Use govern your access to and use of the SmartPeptides QR Hub, including
          activation, links to connected applications, reorder access, and informational content.
          By using the Hub, you accept these Terms and our Privacy Policy.
        </P>
        <P>
          If you do not agree, do not use the Hub. We may update these Terms from time to time,
          and continued use after an update means you accept the revised Terms.
        </P>
      </Section>

      <Section number="02" title="Purpose of the Hub">
        <P>
          The Hub is a post-purchase destination that connects a customer email address to a valid
          distributor code and provides access to ecosystem resources, including protocol
          intelligence, nutrition and activity tools, and reorder pathways.
        </P>
        <P>
          The Hub does not display retail pricing, operate as a public product catalogue, provide
          pharmacy services, or replace the terms that apply to a specific product purchase or
          connected application.
        </P>
      </Section>

      <Section number="03" title="Activation and distributor codes">
        <P>
          A valid distributor code may be used to activate one email identity. After activation,
          that email is permanently linked to the distributor relationship for support and
          convenience. Attempting to link the same email to a different distributor code may be
          rejected.
        </P>
        <P>
          You are responsible for entering accurate information and maintaining control of the
          device and email account used to access the Hub. We may suspend or refuse activation
          where we reasonably suspect fraud, misuse, unauthorized resale, or a security risk.
        </P>
      </Section>

      <Section number="04" title="No medical advice">
        <P>
          The Hub and connected services provide educational, organizational, coaching, tracking,
          and protocol-support information only. They do not provide medical advice, diagnosis,
          treatment, prescribing, emergency services, or a substitute for professional judgment.
        </P>
        <P>
          Consult a qualified physician, pharmacist, or other regulated health professional before
          using, changing, or discontinuing any peptide, medication, supplement, nutrition plan,
          or exercise program. Never disregard professional advice because of information
          presented here.
        </P>
      </Section>

      <Section number="05" title="Products, protocols, and results">
        <P>
          Information about peptides, protocols, biomarkers, nutrition, or activity is general in
          nature unless expressly provided by a qualified professional who has assessed you.
          Individual results vary, and no particular health, performance, body-composition, or
          therapeutic outcome is guaranteed.
        </P>
        <P>
          Product use must follow applicable law, product labeling, professional direction, and
          the instructions supplied with the product.
        </P>
      </Section>

      <Section number="06" title="Third-party applications and distributors">
        <P>
          LIA, Smartplaite, distributor portals, application stores, payment providers, clinicians,
          coaches, and other linked services may be operated by third parties. Their availability,
          features, pricing, privacy practices, and terms are controlled by those providers.
        </P>
        <P>
          A link from the Hub does not mean we control or endorse every third-party statement,
          product, service, or outcome. Your dealings with a distributor or third-party provider
          are between you and that provider unless applicable law says otherwise.
        </P>
      </Section>

      <Section number="07" title="Acceptable use">
        <P>
          You may not misuse the Hub, probe or disrupt its security, submit another person's
          information without authority, scrape or reverse engineer the service except as
          permitted by law, infringe intellectual property rights, or use the Hub for unlawful,
          deceptive, harmful, or unauthorized commercial activity.
        </P>
        <P>
          We may restrict access, preserve evidence, and disclose information where reasonably
          necessary to protect users, distributors, SmartPeptides, the public, or the integrity of
          the service.
        </P>
      </Section>

      <Section number="08" title="Intellectual property">
        <P>
          SmartPeptides, AXIS, LIA, Smartplaite, related logos, text, graphics, interfaces,
          software, and other content are owned by or licensed to SmartPeptides and protected by
          intellectual-property laws. You receive a limited, non-exclusive, non-transferable right
          to use the Hub for its intended personal purpose.
        </P>
        <P>
          No ownership rights are transferred. You may not copy, modify, distribute, sell, or
          create derivative works from Hub content without prior written permission.
        </P>
      </Section>

      <Section number="09" title="Disclaimers and limitation of liability">
        <P>
          To the maximum extent permitted by law, the Hub is provided on an &ldquo;as is&rdquo; and
          &ldquo;as available&rdquo; basis without warranties of uninterrupted operation, accuracy,
          merchantability, fitness for a particular purpose, non-infringement, or error correction.
        </P>
        <P>
          To the maximum extent permitted by law, SmartPeptides and its affiliates will not be
          liable for indirect, incidental, consequential, special, punitive, or exemplary damages,
          or for lost profits, data, goodwill, or opportunities arising from your use of the Hub
          or linked services.
        </P>
      </Section>

      <Section number="10" title="Governing law and contact">
        <P>
          These Terms are governed by the laws of Alberta and the federal laws of Canada
          applicable there, without regard to conflict-of-law rules. Courts located in Alberta
          will have jurisdiction unless applicable consumer law requires another forum.
        </P>
        <P>
          Questions about these Terms may be sent to legal@smartpeptides.ai (placeholder contact),
          c/o Urban Lawyers, Edmonton, Alberta.
        </P>
      </Section>
    </LegalLayout>
  );
}
